import { render, staticRenderFns } from "./provider-addemployee.vue?vue&type=template&id=1bdf06a0&scoped=true"
import script from "./provider-addemployee.vue?vue&type=script&lang=js"
export * from "./provider-addemployee.vue?vue&type=script&lang=js"
import style0 from "./provider-addemployee.vue?vue&type=style&index=0&id=1bdf06a0&prod&scoped=true&lang=css"
import style1 from "./provider-addemployee.vue?vue&type=style&index=1&id=1bdf06a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf06a0",
  null
  
)

export default component.exports